<template>
  <div class="dd-page">
    <header class="dd-header">
      <strong>Docker配信システム</strong
      ><button @click="logout">ログアウト</button>
    </header>
    <main class="dd-main">
      <div class="dd-title">
        <div>
          <h1>Installerアップロード</h1>
          <p>
            登録直後は未公開です。取得許可と公開状態は管理画面で設定します。
          </p>
        </div>
        <button class="secondary" @click="$router.push('/menu')">
          メニューへ戻る
        </button>
      </div>
      <p v-if="error" role="alert" class="dd-message error">{{ error }}</p>
      <p v-if="message" role="status" class="dd-message">{{ message }}</p>
      <section class="dd-panel">
        <form @submit.prevent="upload">
          <fieldset :disabled="busy" style="border: 0; padding: 0; margin: 0">
            <InstallerFields :form="form" />
            <div class="dd-section">
              <label
                >配信ファイル（必須）<input
                  ref="file"
                  type="file"
                  required
                  @change="onFile"
              /></label>
              <p v-if="busy">アップロード中 {{ progress }}%</p>
            </div>
            <div class="dd-actions">
              <button type="submit">アップロード</button
              ><button type="button" class="secondary" @click="reset">
                クリア
              </button>
            </div>
          </fieldset>
        </form>
      </section>
    </main>
  </div>
</template>
<script>
import api from '../api';
import InstallerFields from '../components/InstallerFields';
import { freshInstaller } from '../fields';
export default {
  name: 'UploadView',
  components: { InstallerFields },
  data() {
    return {
      form: freshInstaller(),
      file: null,
      busy: false,
      progress: 0,
      error: '',
      message: '',
    };
  },
  methods: {
    async onFile(e) {
      this.file = e.target.files[0] || null;
      if (!this.file) return;
      if (!/\.exe$/i.test(this.file.name)) return;
      this.busy = true;
      this.error = '';
      try {
        const { data } = await api.post('/api/admin/installers/parse-name', {
          filename: this.file.name,
        });
        Object.assign(this.form, {
          configuration: data.configuration,
          install_kind: data.install_kind,
          change_type: data.change_type,
          docker_version: `Ver.${data.product_version}_${data.build_date}_${data.build_no}`,
          target_os: 'windows',
        });
      } catch (e) {
        this.error = e.response?.data?.error || 'EXE名を解析できません';
      } finally {
        this.busy = false;
      }
    },
    reset() {
      this.form = freshInstaller();
      this.file = null;
      if (this.$refs.file) this.$refs.file.value = '';
    },
    async upload() {
      if (this.busy || !this.file) return;
      this.busy = true;
      this.error = '';
      this.message = '';
      this.progress = 0;
      try {
        const data = new FormData();
        for (const [k, v] of Object.entries(this.form)) data.append(k, v);
        data.append('file', this.file);
        const r = await api.post('/api/docker/upload', data, {
          headers: { 'Content-Type': 'multipart/form-data' },
          onUploadProgress: (e) => {
            if (e.total) this.progress = Math.round((e.loaded / e.total) * 100);
          },
        });
        this.message = `ID ${r.data.docker_id} を未公開で登録しました。SHA-256: ${r.data.sha256}`;
        this.reset();
      } catch (e) {
        this.error = e.response?.data?.error || 'アップロードに失敗しました';
      } finally {
        this.busy = false;
      }
    },
    async logout() {
      await api.post('/api/admin/logout');
      this.$router.push('/login');
    },
  },
};
</script>
